import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { QueryKey } from '../../api/hooks/types';

export const useInvalidateApprovalRequests = () => {
	const queryClient = useQueryClient();

	return useCallback(() => {
		queryClient.invalidateQueries([QueryKey.ApprovalRequests]);
	}, [queryClient]);
};
